import { Component, OnInit } from '@angular/core';
import { DateRangeInterval } from '../../../core/components/date-range/date-range.component';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-time-sheets-status',
  templateUrl: './time-sheets-status.component.html',
  styleUrls: ['./time-sheets-status.component.css']
})
export class TimeSheetsStatusComponent implements OnInit {
    public setting?: Setting;

    public itemsListStatuses: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(1396))[0];
    }

    private async loadStatuses() {
        if (!this.setting) return;

        return this.itemsListStatuses = await this.datatask.Post(276, this.setting);
    }

    public onDateRangeChanged() {
        this.loadStatuses();
    }

    private reloadStatuses(): void {
        setTimeout(() => {
            if (this.setting?.timer_on === '1') {
                this.reloadStatuses();
                this.loadStatuses();
            }
        }, 30000);
    }

    private async init() {
        await this.loadSetting();
        this.loadStatuses();
        this.reloadStatuses();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    date_fom: string;
    date_tom: string;
    dateselector_index: DateRangeInterval;
    filtervalue: string;
    show_setting: string;
    timer_on: string;
}
